"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tip = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
var defs_1 = require("./defs");
function FormItem(props) {
    var _a, _b, _c, _d;
    var prefix = ConfigProvider_1.usePrefix('form-item');
    var size = defs_1.useFormSize(props.size);
    var layout = defs_1.useFormLayout(props.layout);
    var labelOptions = defs_1.useFormLabelOptions({
        labelWidth: props.labelWidth,
        labelGap: props.labelGap,
        labelAlign: props.labelAlign,
        labelColor: props.labelColor,
        labelVerticalAlign: props.labelVerticalAlign
    });
    var verticalGap = defs_1.useFormVerticalGap(undefined);
    var validateStatus = (_a = props.validateStatus) !== null && _a !== void 0 ? _a : defs_1.defaultValidateStatus;
    var className = classnames_1.default(prefix, props.className, utils_1.concat(prefix, 'size', size), utils_1.concat(prefix, 'layout', layout.type), utils_1.concat(prefix, 'validate-status', validateStatus));
    var style = tslib_1.__assign({ marginBottom: verticalGap }, props.style);
    var labelClassName = classnames_1.default(utils_1.concat(prefix, 'label'), props.required && utils_1.concat(prefix, 'label', 'required'), layout.type === 'horizontal' && utils_1.concat(prefix, 'label', 'align', (_b = labelOptions.labelAlign) !== null && _b !== void 0 ? _b : defs_1.defaultLabelAlign), layout.type === 'horizontal' && utils_1.concat(prefix, 'label', 'vertical-align', (_c = labelOptions.labelVerticalAlign) !== null && _c !== void 0 ? _c : defs_1.defaultLabelVerticalAlign));
    var labelMarginRight = (function () {
        var _a, _b;
        if (layout.type === 'horizontal')
            return (_a = labelOptions.labelGap) !== null && _a !== void 0 ? _a : defs_1.defaultLabelGapForHorizontal;
        if (layout.type === 'inline')
            return (_b = labelOptions.labelGap) !== null && _b !== void 0 ? _b : defs_1.defaultLabelGapForInline;
    })();
    var labelStyle = {
        flexBasis: layout.type === 'horizontal' ? ((_d = labelOptions.labelWidth) !== null && _d !== void 0 ? _d : defs_1.defaultLabelWidth) : undefined,
        color: defs_1.normalizeLabelColor(labelOptions.labelColor),
        marginRight: labelMarginRight
    };
    var validateResult = {
        status: validateStatus,
        message: props.validateMessage
    };
    var tipView = props.tip != null && react_1.default.createElement(Tip, null, props.tip);
    return (react_1.default.createElement("section", { className: className, style: style },
        props.label != null && react_1.default.createElement("div", { className: labelClassName, style: labelStyle }, props.label),
        react_1.default.createElement("div", { className: utils_1.concat(prefix, 'body') },
            react_1.default.createElement("div", { className: utils_1.concat(prefix, 'content') },
                react_1.default.createElement(defs_1.sizeCtx.Provider, { value: size },
                    react_1.default.createElement(defs_1.layoutCtx.Provider, { value: layout },
                        react_1.default.createElement(defs_1.validateResultCtx.Provider, { value: validateResult }, props.children)))),
            react_1.default.createElement("div", { className: utils_1.concat(prefix, 'extra') },
                react_1.default.createElement("div", { className: utils_1.concat(prefix, 'validate-message') }, props.validateMessage),
                tipView))));
}
exports.default = FormItem;
function Tip(_a) {
    var children = _a.children;
    var prefix = ConfigProvider_1.usePrefix('form-item');
    return react_1.default.createElement("div", { className: utils_1.concat(prefix, 'tip') }, children);
}
exports.Tip = Tip;
//# sourceMappingURL=FormItem.js.map